import { render, staticRenderFns } from "./CompanyStockRelationshipChart.vue?vue&type=template&id=36559ace&scoped=true"
import script from "./CompanyStockRelationshipChart.vue?vue&type=script&lang=ts"
export * from "./CompanyStockRelationshipChart.vue?vue&type=script&lang=ts"
import style0 from "./CompanyStockRelationshipChart.vue?vue&type=style&index=0&id=36559ace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36559ace",
  null
  
)

export default component.exports